import { fetchOrder, fetchOrders, setOrderState } from './asyncThunks';

export const fetchOrdersBuilder = builder => {
  builder.addCase(fetchOrders.pending, state => {
    state.fetchOrdersPending = true;
  });
  builder.addCase(fetchOrders.fulfilled, (state, { payload }) => {
    state.fetchOrdersPending = false;
    const { data, maxReached, page, total, perPage } = payload.data;

    state.orders.data = data;
    state.orders.maxReached = maxReached;
    state.orders.total = total;
    state.orders.page = page;
    state.orders.perPage = perPage;
  });
  builder.addCase(fetchOrders.rejected, state => {
    state.fetchOrdersPending = false;
  });
};

export const fetchOrderBuilder = builder => {
  builder.addCase(fetchOrder.pending, state => {
    state.order.loading = true;
  });
  builder.addCase(fetchOrder.fulfilled, (state, { payload }) => {
    state.fetchOrderPending = false;
    const data = payload.data;
    state.order.data = data;
    state.order.loading = false;
  });
  builder.addCase(fetchOrder.rejected, state => {
    state.order.loading = false;
  });
};

export const setOrderStateBuilder = builder => {
  builder.addCase(setOrderState.pending, state => {
    state.setOrderStatePending = true;
  });
  builder.addCase(setOrderState.fulfilled, (state, { payload }) => {
    const { data } = payload;

    state.orders.data = state.orders.data.map(order => {
      if (order.id === data.id) {
        order = data;
      }
      return order;
    });

    state.setOrderStatePending = false;
  });
  builder.addCase(setOrderState.rejected, state => {
    state.setOrderStatePending = false;
  });
};
